import { render, staticRenderFns } from "./RequestAccreditation.view.vue?vue&type=template&id=46960320"
import script from "./RequestAccreditation.view.vue?vue&type=script&lang=js"
export * from "./RequestAccreditation.view.vue?vue&type=script&lang=js"
import style0 from "./RequestAccreditation.view.vue?vue&type=style&index=0&id=46960320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports